import * as auth from '@/utils/auth'
import isEmpty from 'lodash/isEmpty'
import {authRequest, request} from "@/utils/request";

const getDefaultState = () => {
    return {
        user: auth.getUser(),
        accessToken: auth.getToken(),
        accessTokenExpiredAt: auth.getTokenExpiredAt()
    }
}

const state = getDefaultState()

const getters = {
    isLoggedIn: state => !isEmpty(state.accessToken),
    user: state => state.user,
    accessToken: state => state.accessToken,
    accessTokenExpiredAt: state => state.accessTokenExpiredAt
}

const mutations = {
    setUser(state, user) {
        state.user = user
    },
    setToken(state, tokenPayload) {
        state.accessToken = tokenPayload.access_token
        state.accessTokenExpiredAt = new Date().getTime() + tokenPayload.expires_in * 1000
    },
    resetState: (state) => {
        Object.assign(state, getDefaultState())
    }
}

const actions = {
    async login({dispatch, commit}, params = {}) {
        const authResponse = await request('phone/authorizations', {
            method: 'POST',
            data: params
        })

        commit('setToken', authResponse.data)
        auth.setToken(authResponse.data)

        dispatch('getUser')
    },
    async passLogin({dispatch, commit}, params = {}) {
        const authResponse = await request('pass/authorizations', {
            method: 'POST',
            data: params
        })

        commit('setToken', authResponse.data)
        auth.setToken(authResponse.data)

        dispatch('getUser')
    },
    async getUser({dispatch, commit}) {
        const userResponse = await authRequest('user', {
            method: 'GET'
        })

        commit('setUser', userResponse.data.data)
        auth.setUser(userResponse.data.data)
    },
    async refresh({dispatch, commit, state}, params = {}) {
        const refreshResponse = await request('authorizations/current', {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + state.accessToken
            }
        })

        commit('setToken', refreshResponse.data)
        auth.setToken(refreshResponse.data)

        dispatch('getUser')
    },
    async logout({commit}) {
        // await authRequest('authorizations/current', {
        //     method: 'DELETE'
        // })

        // 清空 storage
        auth.logout()
        commit('resetState')
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}